import axios, { AxiosError } from 'axios';
import store from '../store';
import { showErrorMessage } from '../store/application';

export const sessionExpiredError = 'Ha expirado su sesión';
export const genericError = 'Error de conexión';
export const predefinedErrors: { [key: string]: string } = {
  invalid_grant: 'Usuario o contraseña inválidos',
};

function stringForCode(code: string): string {
  if (code in predefinedErrors) {
    return predefinedErrors[code];
  }
  return genericError;
}

/**
 * Displays a toast notification describing the error, or will show a fallback
 * message if no custom error is defined for the response.
 *
 * @param error - The error reported by axios
 */
export default function injectNetworkErrorNotifier(error: AxiosError): void {
  // Ignore cancels
  if (axios.isCancel(error)) {
    return;
  }

  if (error && error.response) {
    if (error.response.status === 401) {
      store.dispatch(showErrorMessage(sessionExpiredError));
    } else {
      const errorCode = error.response.data.error;
      store.dispatch(showErrorMessage(stringForCode(errorCode)));
    }
    return;
  }
  store.dispatch(showErrorMessage(genericError));
}
